import { Box, Spinner } from "@chakra-ui/react";
import { useApi } from "@raiden/library/hooks/useApi";
import generateApiUrl from "@raiden/library/libraries/utils/generateApiUrl";
import { CustomContentRenderer } from "../../../../components/CustomContentRender";
import { DataHandler } from "../../../../components/DataHandler";

/**
 * @typedef {Object} Props
 * @property {number | string} [idOrAlias] used to fetch the post to render
 * @property {import("@raiden/library/types/Post").Post} [post] used to render the post if already fetched
 *
 * @param {Props} props
 */
export function PostsContentView({ idOrAlias, post }) {
  const strIdOrAlias =
    idOrAlias !== undefined ? idOrAlias.toString() : undefined;

  /** @type {import("@raiden/library/hooks/useApi").UseApi<import("@raiden/library/types/Post").Post>} */
  const { swrResponse } = useApi(
    post === undefined && (strIdOrAlias?.length ?? 0) > 0
      ? generateApiUrl({
          id: "@api.posts.view",
          parameters: {
            postId: idOrAlias,
          },
          query: {
            fields: ["post.current_revision"],
          },
        })
      : null,
  );

  return (
    <>
      {post ? (
        <CustomContentRenderer content={post.current_revision?.content} />
      ) : (
        <DataHandler
          swrResponse={swrResponse}
          keepDataOnRevalidation={true}
          loading={
            <Box px="1rem">
              <Spinner />
            </Box>
          }>
          {({ data: post }) => (
            <CustomContentRenderer content={post.current_revision?.content} />
          )}
        </DataHandler>
      )}
    </>
  );
}
